const BASE_URL = "https://amubackend.infitouch.in/";

const APIS = {
    EMPLOYEE_LOGIN: BASE_URL + "empoyeeLogin?email=" ,
    GET_AMU_CRIF_REPORT: BASE_URL + "getAMUCrifReport?empId=" ,
    SEND_AMU_OTP_BY_MOBILE_NUMBER: BASE_URL + "sendAMUOTP?mobile=" ,
    VERIFY_AMU_OTP_BY_MOBILE_NUMBER: BASE_URL + "getAMUOTP?mobile=" ,
    GET_AMU_ANALYSIS: BASE_URL + "getAMUAnalysis" ,
}


export {
    APIS,
    BASE_URL
}